export const LIST_NAME = {
	ALL_GAMES: 'All Games',
	MY_GAMES: 'My Games',
	PROVIDER_GAMES: 'Provider Games',
	SUBPROVIDER_GAMES: 'SubProvider Games',
	EXPLORE: 'Explore',
	GAME_INFO: 'Game info'
} as const;

export const GAME_MODE = {
	REAL: 'real',
	FUN: 'fun'
} as const;
